import * as React from 'react';
import Box from '@mui/material/Box';
import Bs4Kartoteka from '../Bs4Kartoteka';

const NO_DRAGGABLE = 'Bs4FormElementNoDraggable';

export default class Bs4FormElement {  

  constructor(props) {
    this.props = props;
    this.bs4KartotekaId = props?.bs4KartotekaId;
    this.optionId = props?.optionId;
    this.inputId = props?.inputId;
    this.formId = props?.formId || this.inputId || 0;
  }

  formElementArray = [];
  formId = 0;

  getPageParam = (param) => Bs4Kartoteka.get(this.bs4KartotekaId)?.message?._Komunikat?.pageParams[this.optionId]?.[param];

  getElementId = (name) => `${this.constructor.name}_${this.optionId || '?'}_${this.inputId || '?'}${name ? '_'+name : ''}`;

  hesValue() {return false}

  displayElementDom = 'block';

  removeElementDom = () => {
    this.displayElementDom = 'none';
    console.log('=== NOTE === removeElementDom has not yet been implemented');
  }
  
  showElementDom = () => {
    this.displayElementDom = 'block';
    console.log('=== NOTE === showElementDom has not yet been implemented');
  }
  
  getParentNodeById = (id, e) => { 
    if (!e?.parentNode) return null;
      //console.log('...getParentNodeById...', id, e.parentNode.id)
    if (id === e.parentNode.id) {
      //console.log('...getParentNodeById...', id, e.parentNode.id)
      return e.parentNode;
    }    
    return this.getParentNodeById(id, e.parentNode)
  }

  isEqualId = (id) => {    
    if (this.props.inputId && String(this.props.inputId) === String(id)) return true;
    return false;
  }
  
  getGrilleBox = (type, colorA, colorB, ii) => {
    let grilleColorA = null;
    let grilleColorB = null;
    switch (type) {
      case 1:
        grilleColorA = '#00000020';
        grilleColorB = '#00000000';
        break;
      case 2:
        grilleColorA = '#00ff0020';
        grilleColorB = '#00ff0005';
        break;
      default:
        grilleColorA = '#00000032';
        grilleColorB = '#00000000';
        break;
    }

    const i = ii || 8;
    grilleColorA = colorA || grilleColorA;
    grilleColorB = colorB || grilleColorB;

    return {
      backgroundImage: `linear-gradient(45deg, ${grilleColorA} 25%, ${grilleColorB} 25%), linear-gradient(-45deg, ${grilleColorA} 25%, ${grilleColorB} 25%), linear-gradient(45deg, ${grilleColorB} 75%, ${grilleColorA} 75%), linear-gradient(-45deg, ${grilleColorB} 75%, ${grilleColorA} 75%)`,
      backgroundSize: `${i*2}px ${i*2}px`,
      backgroundPosition: `0 0, 0 ${i}px, ${i}px -${i}px, -${i}px 0px`,
      borderColor: grilleColorA,
      borderStyle: 'solid', 
      borderWidth: 2+'px',
    }
  }

  getFormElementSize  = () => null;
  colisionBefore = false;
  formElementType = null;

  ViewComponent = (props) => {
    return (
      <React.Fragment>
        {props.children}
      </React.Fragment>
    )
  }
}